export default __webpack_public_path__ + "static/media/disc_active1.e53edead.png";